import React, { useEffect, useState } from "react";
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import { doc, query, orderBy, collection, onSnapshot, updateDoc, addDoc, deleteDoc, serverTimestamp } from "firebase/firestore";
import styles from "./RulesTab.module.css";
import { HiOutlinePencil, HiOutlineTrash, HiPlusCircle, HiXMark } from "react-icons/hi2";
import { DEBATE_FEED_RULES } from '../debateFormatMechanics';
import Button from '../../ui/Button';


const RulesTab = ({ formatId, arenaId, isModerator }) => {
  const [rules, setRules] = useState([]);
  const [editingRule, setEditingRule] = useState(null);
  const [editText, setEditText] = useState("");
  const debaterules = DEBATE_FEED_RULES[formatId];
  
	useEffect(() => {
	const q = query(
	  collection(firestore, 'arenas', arenaId, 'arenarules'), orderBy('createdAt', 'desc')
	);
	const unsubscribe = onSnapshot(q, snapshot => {
	  setRules(snapshot.docs.map(d => ({ docid: d.id, ...d.data().rules }))  || []);
	});
	return () => unsubscribe();
	}, [arenaId]);

  const updateRules = async (newRules) => {
	if(newRules.docid != undefined) {
		await updateDoc(doc(firestore,'arenas', arenaId, 'arenarules', newRules.docid), {
			rules: newRules, createdAt: serverTimestamp()
		});
	}
	else 
	{
	  await addDoc(collection(firestore, 'arenas', arenaId, 'arenarules'), {
		rules: newRules, createdAt: serverTimestamp()
	  });
	}
  };

  const deleteRules = async (newRules) => {
	if(newRules.docid != undefined) {
		await deleteDoc(doc(firestore,'arenas', arenaId, 'arenarules', newRules.docid));
	}
  };

  const handleAddRule = () => {
    setEditingRule({ id: `r${Date.now()}`, isNew: true });
    setEditText("");
  };

  const handleEditRule = (id) => {
    const rule = rules.find((r) => r.id === id);
	setEditingRule(rule);
    setEditText(rule.text);
  };

  const handleDeleteRule = (id) => {
    //if (!window.confirm("Delete this rule?")) return;
    const newRules = rules.filter((r) => r.id === id);
    deleteRules(newRules[0]);
  };

  const handleSave = () => {
    if (!editText.trim()) return;

    let newRules;
    if (editingRule.isNew) {
		const newRules = { id: editingRule.id, text: editText };
		updateRules(newRules);
    } else {
      editingRule.text = editText;
	  updateRules(editingRule);
    }
    setEditingRule(null);
    setEditText("");
  };

  const handleCancel = () => {
    setEditingRule(null);
    setEditText("");
  };
  
  return (
    <div className={styles.rulesTab}>
      <h2>Permanent Rules</h2>
      <ol className={styles.rulesList}>
          <li  className={styles.ruleItem}>
            {debaterules.turnLogic}
          </li>
        {debaterules.scoring.criteria.map((rule, i) => (
          <li key={i} className={styles.ruleItem}>
            {rule}
          </li>
        ))}
      </ol>
      <h2 className={styles.header}>Moderator Rules</h2>
      <ol className={styles.rulesList}>
        {rules.map((rule) => (
          <li key={rule.docid} className={styles.ruleItem}>
            <span>{rule.text}</span>
            {isModerator && (
              <span className={styles.controls}>
                <HiOutlinePencil onClick={() => handleEditRule(rule.id)} />
                <HiOutlineTrash onClick={() => handleDeleteRule(rule.id)} />
              </span>
            )}
          </li>
        ))}
      </ol>

      {isModerator && (
        <Button className={styles.addRuleBtn} onClick={handleAddRule}>
          <HiPlusCircle /> Add Rule
        </Button>
      )}
	  
      {/* Edit Modal */}
      {editingRule && (
          <div className={styles.modalBox}>
            <div className={styles.modalHeader}>
              <h3>{editingRule.isNew ? "Add New Rule" : "Edit Rule"}</h3>
              <HiXMark className={styles.closeIcon} onClick={handleCancel} />
            </div>

            <textarea
              className={styles.textarea}
              value={editText}
              onChange={(e) => setEditText(e.target.value)}
              maxLength={300}
              rows={4}
              placeholder="Enter rule text..." />
            <div className={styles.charCount}>
              {editText.length} / 300
            </div>

            <div className={styles.modalActions}>
              <Button className={styles.cancelBtn} onClick={handleCancel}>
                Cancel
              </Button>
              <Button className={styles.saveBtn} onClick={handleSave}>
                Save
              </Button>
            </div>
          </div>
      )}
    </div>
  );
};

export default RulesTab;